import type { ReactNode } from 'react';

import type { TabsItem } from '@/components/tabs';
import { InventorySiteSection } from '@/types.ts';

import { WidgetSiteTabbedPanelPadding } from './inventorySiteSections.styles.ts';

type BuildVerticalSiteTabItemsOptions = {
  sections: readonly InventorySiteSection[];
  renderPanel: (section: InventorySiteSection) => ReactNode;
  formatTabLabel?: (section: InventorySiteSection) => string;
  showItemCount?: boolean;
  keepTabPanelsMounted?: boolean;
};

export const buildVerticalSiteTabItems = ({
  sections,
  renderPanel,
  formatTabLabel,
  showItemCount = true,
  keepTabPanelsMounted = false,
}: BuildVerticalSiteTabItemsOptions): TabsItem[] =>
  sections.map(section => ({
    value: section.siteKey,
    tab: {
      children:
        formatTabLabel?.(section) ??
        (showItemCount ? `${section.siteTitle} (${section.items.length})` : section.siteTitle),
    },
    panel: {
      keepMounted: keepTabPanelsMounted,
      children: <WidgetSiteTabbedPanelPadding>{renderPanel(section)}</WidgetSiteTabbedPanelPadding>,
    },
  }));
